/* project files imports */
import lanaDelRey from "assets/images/demo/lana-del-rey.jpg";
import taylorSwift from "assets/images/demo/taylor-swift.jpg";
import theWeeknd from "assets/images/demo/the-weeknd.jpg";
import billieEilish from "assets/images/demo/billie-eilish.jpg";
import kanyeWest from "assets/images/demo/kanye-west.jpg";
import kendrickLamar from "assets/images/demo/kendrick-lamar.jpg";
import tylerTheCreator from "assets/images/demo/tyler-the-creator.jpg";
import drake from "assets/images/demo/drake.jpg";
import ladyGaga from "assets/images/demo/lady-gaga.jpg";
import charliXcx from "assets/images/demo/charli-xcx.jpg";
import arianaGrande from "assets/images/demo/ariana-grande.jpg";
import sza from "assets/images/demo/sza.jpg";
import oliviaRodrigo from "assets/images/demo/olivia-rodrigo.jpg";
import metroBoomin from "assets/images/demo/metro-boomin.jpg";
import theBeatles from "assets/images/demo/the-beatles.jpg";
import frankOcean from "assets/images/demo/frank-ocean.jpg";
import rihanna from "assets/images/demo/rihanna.jpg";
import dojaCat from "assets/images/demo/doja-cat.jpg";
import bladee from "assets/images/demo/bladee.jpg";
import harryStyles from "assets/images/demo/harry-styles.jpg";
import pinkpantheress from "assets/images/demo/pinkpantheress.jpg";
import beyonce from "assets/images/demo/beyonce.jpg";
import eminem from "assets/images/demo/eminem.jpg";
import sabrinaCarpenter from "assets/images/demo/sabrina-carpenter.jpg";
import playboiCarti from "assets/images/demo/playboi-carti.jpg";
import travisScott from "assets/images/demo/travis-scott.jpg";
import macDemarco from "assets/images/demo/mac-demarco.jpg";
import macMiller from "assets/images/demo/mac-miller.jpg";
import clairo from "assets/images/demo/clairo.jpg";
import jul from "assets/images/demo/jul.jpg";

type DemoArtist = {
  name: string;
  picture: string;
};

/**
 * Artists found most often in users' top artists,
 * used for the demo round on the login page
 */
export const DEMO_ARTISTS: DemoArtist[] = [
  { name: "Lana Del Rey", picture: lanaDelRey },
  { name: "Taylor Swift", picture: taylorSwift },
  { name: "The Weeknd", picture: theWeeknd },
  { name: "Billie Eilish", picture: billieEilish },
  { name: "Kanye West", picture: kanyeWest },
  { name: "Kendrick Lamar", picture: kendrickLamar },
  { name: "Tyler, The Creator", picture: tylerTheCreator },
  { name: "Drake", picture: drake },
  { name: "Lady Gaga", picture: ladyGaga },
  { name: "Charli XCX", picture: charliXcx },
  { name: "Ariana Grande", picture: arianaGrande },
  { name: "SZA", picture: sza },
  { name: "Olivia Rodrigo", picture: oliviaRodrigo },
  { name: "Metro Boomin", picture: metroBoomin },
  { name: "The Beatles", picture: theBeatles },
  { name: "Frank Ocean", picture: frankOcean },
  { name: "Rihanna", picture: rihanna },
  { name: "Doja Cat", picture: dojaCat },
  { name: "Bladee", picture: bladee },
  { name: "Harry Styles", picture: harryStyles },
  { name: "PinkPantheress", picture: pinkpantheress },
  { name: "Beyoncé", picture: beyonce },
  { name: "Eminem", picture: eminem },
  { name: "Sabrina Carpenter", picture: sabrinaCarpenter },
  { name: "Playboi Carti", picture: playboiCarti },
  { name: "Travis Scott", picture: travisScott },
  { name: "Mac DeMarco", picture: macDemarco },
  { name: "Mac Miller", picture: macMiller },
  { name: "Clairo", picture: clairo },
  { name: "Jul", picture: jul }
];

export default { DEMO_ARTISTS };
